import { AppPage } from '@framework/page';
import PageMeta from '@framework/page-meta';
import { getAppLayoutWithCart } from '@layouts/app-layout/app-layout';
import { getApp } from '@utils/app';
import { getServerSideTranslationProps } from '@utils/i18n';
import { GetServerSideProps } from 'next';
import { useTranslation } from 'react-i18next';
import ContactView from '../views/contact-view/contact-view';

const ContactPage: AppPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageMeta pageTitle={t('contact.view_title')} description={''} />
      <ContactView />
    </>
  );
};

ContactPage.getLayout = (page) => {
  return getAppLayoutWithCart(page);
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const app = getApp(context);

  const translationProps = await getServerSideTranslationProps(app, 'messages');

  return {
    props: {
      ...translationProps,
    },
  };
};

export default ContactPage;
